export default {
  cancel: 'Abbrechen',
  circle_config: 'Zirkel Einstellung',
  confirm: 'Bestätigen',
  confirm_delete: 'Bestätigung des Löschvorgang',
  create: 'Erstellen',
  delete_geometry: 'Geometrie entfernen',
  delete_vertex: 'Entferne Scheitelpunkt',
  document_upload_failed: 'Hochladen des Dokumentes gescheitert.',
  draw_circle: 'Zirkel',
  draw_circle_2pt: '2 Punkt Zirkel',
  draw_dialog_begin_drawing: 'Beginne Zeichnung - Klicke auf die Karte',
  draw_dialog_cancel_drawing: 'Zeichnung abbrechen - ESC Taste',
  draw_dialog_remove_vertex:
    'Entferne letzten Scheitelpunkt - Rechte Maustaste',
  draw_dialog_save: 'Speichern - Doppelklick',
  draw_dialog_save_single: 'Speichern - Einzelklick',
  draw_dialog_title: 'Zeichnungsanweisungen',
  draw_line: 'Linie',
  draw_point: 'Punkt',
  draw_polygon: 'Polygon',
  draw_position: 'Aktueller Standort',
  draw_rectangle: 'Rechteck',
  edit_dialog_cancel_drawing: 'Zeichnungen abbrechen',
  edit_dialog_modify_shape: 'Form bearbeiten',
  edit_dialog_remove_vertex: 'Scheitelpunkt entfernen',
  edit_dialog_save: 'Speichern',
  edit_dialog_title: 'Bearbeitungsanweisungen',
  filter_searchbox_placeholder: 'Suche',
  icon_scaling_cluster: 'Cluster Icon Skalierung',
  icon_scaling_cluster_log: 'Cluster Log Skalierung',
  icon_scaling_field: 'Umschalten der Feld Icon Skalierung',
  icon_scaling_label: 'Icon Skalierung',
  icon_scaling_zoom_in: 'Zoom-in Skalierung',
  icon_scaling_zoom_out: 'Zoom-out Skalierung',
  identical_values_filter:
    'Dieses Feld enthält nur einen eindeutigen Wert und kann nicht gefiltert werden.',
  image_upload_failed: 'Hochladen des Bildes gescheitert.',
  information: 'Information',
  invalid_geometry: 'Ungültige Geometrie',
  invalid_lat_lon: 'Koordinate liegt außerhalb der Lokale.',
  invalid_lat_long_range: 'Falsche Eingabe von Latitude / Longitude.',
  layer_add_new_location: 'Erstelle neue Lage',
  layer_dataview_header: 'Datenansichten',
  layer_filter_clear_all: 'Entferne alle Filter',
  layer_filter_dropdown_select: 'Mehrfachauswahl',
  layer_filter_greater_than: 'Mehr als',
  layer_filter_header: 'Filter',
  layer_filter_less_than: 'Weniger als',
  layer_filter_reset_all: 'Setze alle Filter zurück',
  layer_filter_select: 'Filter Auswahl',
  layer_filter_set_filter: 'Filter einstellen',
  layer_grid_legend_ratio: 'Farbe im Verhältnis zur Größe',
  layer_group_hide_layers: 'Ausschalten aller Ebenen in Gruppe',
  layer_style_cluster: 'Mehrere Lagen',
  layer_style_display_hover: 'Hover Einschalten',
  layer_style_display_labels: 'Umschalten der Label Ansicht',
  layer_style_header: 'Stil',
  layer_style_opacity: 'Ebenen-Deckkraft ändern:',
  layer_style_select_theme: 'Auswahl eines thematischen Stiles',
  layer_style_switch_all: 'Alle auswählen',
  layer_style_switch_caption: 'Auswahl der Label schaltet Ansicht um oder',
  layer_visibility: 'Umschalten der Ansicht',
  layer_zoom_to_extent: 'Zoom zum Ausmaß des gefilterten Datensatzes',
  layers: 'Ebenen',
  link: 'Link',
  loading: 'Wird geladen',
  location_clear_all: 'Entferne Auswahl',
  location_close_without_save: 'Schließen ohne Speichern',
  location_delete: 'Löschen der Lage',
  location_listview_full: 'Lagenliste ist voll.',
  location_remove: 'Lagen Auswahl aufheben',
  location_save: 'Speichern der Datenänderungen',
  location_save_changes: 'Ihre Änderungen an dieser Lage speichern?',
  location_zoom: 'Ansicht den Lagen Geometrien anpassen',
  locations: 'Orte',
  modify_geometry: 'Geometrie bearbeiten',
  no_data_filter:
    'Dieses Feld enthält keine Daten und kann nicht gefiltert werden.',
  no_layers: 'Keine zugänglichen Ebenen im Bereich.',
  no_locales:
    'Ihr Konto wurde verifiziert und genehmigt, aber Sie haben keinen Zugriff auf irgendwelche Bereiche. Dies liegt wahrscheinlich daran, dass ein Administrator Ihnen nicht die erforderlichen Rollen zugewiesen hat. Bitte wenden Sie sich an einen Administrator, um das Problem zu beheben.',
  no_options_available: 'Keine Auswahl verfügbar',
  no_results: 'Suche ist ergebnislos',
  ok: 'OK',
  pill_component_remove: 'Entfernen',
  pin: 'Pin',
  radius: 'Radius',
  remove_document_confirm: 'Dokument entfernen?',
  remove_image_confirm: 'Bild entfernen?',
  remove_item_confirm: 'Element entfernen?',
  remove_last_vertex: 'Entferne letzten Scheitelpunkt',
  report: 'Report',
  save: 'Speichern',
  toolbar_admin: 'Benutzerkontenverwaltung',
  toolbar_current_location: 'Standort',
  toolbar_fullscreen: 'Vollbild',
  toolbar_login: 'Einloggen',
  toolbar_logout: 'Ausloggen',
  toolbar_zoom_in: 'Zoom rein',
  toolbar_zoom_out: 'Zoom raus',
  toolbar_zoom_to_area: 'Zoom Rechteck',
  units: 'Masseinheit',
  zoom_to: 'Heranzoomen',
};
